module.exports = __webpack_public_path__ + "img/bus-double-decker.8962be6f.svg";